import React, { useEffect } from 'react';
import Lottie from '../Lottie/Lottie';
import { LoaderProps } from './Loader.types';
import standardAnimation from './Loading_Spinner_data.json';
import buttonAnimation from './Loading_Spinner_Button_data.json';

const Loader = ({ label = 'Loading', button = false }: LoaderProps) => {
  useEffect(() => {
    const loader = document.getElementsByTagName('svg')[0];
    loader.setAttribute('viewBox', '40 40 240 240');
  }, []);
  return (
    <Lottie
      animationData={button ? buttonAnimation : standardAnimation}
      aria-busy="true"
      aria-label={label}
      aria-live="polite"
      label={label}
      role="alert"
      style={{
        height: '24px',
        width: '24px',
        margin: 'auto',
        display: 'block',
      }}
      wrapperElement="span"
    />
  );
};

export default Loader;
